import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { EditAdminDetail, MasterAdminLoader } from "../../../Redux/Action/MasterAdminAction";
import { MdClose } from "react-icons/md";
import { X } from "lucide-react";

// admin edit Modal

export const AdminEditModal = ({ fromData , setEditCorpModel , editData , setEditId, editCorpModel}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactno, setContactno] = useState("");
  const [error, seterror] = useState("");

  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if(editData){
        setName(editData.name);
        setEmail(editData.email);
        setContactno(editData.contactno);
    }
  }, [editData]);

  const handleSubmit = (e) => {

    e.preventDefault();
    const formData = {
      name,
      email,
      contactno,
    };
    if (name.trim() === "") {
      seterror("Please enter a valid name.");
      return;
    }
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    dispatch(EditAdminDetail(editData._id , formData, { ...object } , setEditCorpModel));
    dispatch(MasterAdminLoader());
  };

  return (
    <>
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          editCorpModel ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <h2 className="text-xl font-semibold text-gray-900 my-[7px]">
              Edit Admin
            </h2>
          </div>
          <button
            onClick={() => setEditCorpModel(false)}
            className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <form onSubmit={handleSubmit} id="editForm">
            <div className="flex flex-col gap-3 p-3 xl:p-5">
              {fromData === false && (
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Branch Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    type="text"
                    className="py-[10px] xl:py-3 px-4 disabled:cursor-not-allowed rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                    placeholder="Enter Admin Name"
                    id="name"
                    name="name"
                    value={editData?.branchName}
                    disabled
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
              )}
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Admin Name<span className="text-[#fc0000]">*</span> :
                </span>
                <input
                  type="text"
                  className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                  placeholder="Enter Admin Name"
                  id="name"
                  name="name"
                  value={name}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(
                      /[^a-zA-Z0-9\s]/g,
                      ""
                    ))
                  }
                  onChange={(e) => {
                    const enteredValue = e.target.value;
                    const trimmedValue = enteredValue.trim();
                    if (trimmedValue !== "" || enteredValue === "") {
                      setName(enteredValue);
                    }
                  }}
                  required
                  autoComplete="off"
                  maxLength={50}
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Email Id<span className="text-[#fc0000]">*</span> :
                </span>
                <input
                  type="email"
                  className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                  placeholder="Enter Admin Email Id"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="off"
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-Poppins text-[15px] xl:text-base">
                  Contact No<span className="text-[#fc0000]">*</span> :
                </span>
                <input
                  type="tel"
                  className="py-[10px] xl:py-3 px-4 text-sm rounded-lg bg-[#FFFCE1] outline-[#FCDD00]"
                  placeholder="Enter Admin Contact No"
                  id="contact"
                  name="contact"
                  value={contactno}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9+]/g, ""))
                  }
                  onChange={(e) => setContactno(e.target.value)}
                  minLength={0}
                  // maxLength={10}
                  required
                  autoComplete="off"
                />
              </div>
              {error && <p className="text-[#fc0000]">{error}</p>}
            </div>
          </form>
        </div>
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50 ">
          <button
            form="editForm"
            type="submit"
            className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
          >
            Save
          </button>

          <button onClick={() => setEditCorpModel(false)} className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
            close
          </button>
        </div>
      </div>
    </>
  );
};

// Member Edit Modal

export const MemberEditModal = ({ setEditCorpModel , editData , setEditId}) => {
    const dispatch = useDispatch();
    const location = useLocation();
  
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contactno, setContactno] = useState("");
    const [error, seterror] = useState("");
  
    useEffect(() => {
      if(editData){
          setName(editData.name);
          setEmail(editData.email);
          setContactno(editData.contactno);
      }
    }, [editData]);
  
    const handleSubmit = (e) => {
  
      e.preventDefault();
      const formData = {
        name,
        email,
        contactno,
      };
      if (name.trim() === "") {
        seterror("Please enter a valid name.");
        return;
      }
      const sds = location.search.slice(1).split("&");
      let object = {};
      if (location.search.includes("?")) {
        sds.map((item) => {
          let newItem = item.split("=");
          object[newItem[0]] = newItem[1];
        });
      }
      dispatch(EditAdminDetail(editData._id , formData, { ...object } , setEditCorpModel));
      dispatch(MasterAdminLoader());
    };
  
    return (
      <>
        <div className="fixed top-0 left-0 right-0 z-30 w-full h-full bg-black bg-opacity-50">
          <div className="w-[340px] sm:w-[450px] bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px]">
            <div className="flex items-center justify-between px-3 py-2 text-xl uppercase rounded-t-2xl xl:px-5 xl:py-3 font-Poppins">
              <div className="text-[18px] xl:text-xl">Edit Admin 1</div>
              <button
                onClick={() => {
                  setEditCorpModel(false);
                  setEditId("");
                }}
              >
                <MdClose className="text-2xl text-gray-500 hover:text-black" />
              </button>
            </div>
            <hr></hr>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-3 p-3 xl:p-5">
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Branch Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    type="text"
                    className="py-[10px] xl:py-3 px-4 disabled:cursor-not-allowed rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                    placeholder="Enter Admin Name"
                    id="name"
                    name="name"
                    value={editData?.branchName}
                  disabled
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Admin Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    type="text"
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                    placeholder="Enter Admin Name"
                    id="name"
                    name="name"
                    value={name}
                    onInput={(e) =>
                    (e.target.value = e.target.value.replace(
                      /[^a-zA-Z0-9\s]/g,
                      ""
                    ))
                    }
                    onChange={(e) => {
                      const enteredValue = e.target.value;
                      const trimmedValue = enteredValue.trim();
                      if (trimmedValue !== "" || enteredValue === "") {
                        setName(enteredValue);
                      }
                    }}
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Email Id<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    type="email"
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                    placeholder="Enter Admin Email Id"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Contact No<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    type="tel"
                    className="py-[10px] xl:py-3 px-4 text-sm rounded-lg bg-[#FFFCE1] outline-[#FCDD00]"
                    placeholder="Enter Admin Contact No"
                    id="contact"
                    name="contact"
                    value={contactno}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9+]/g, ""))
                    }
                    onChange={(e) => setContactno(e.target.value)}
                    minLength={0}
                    // maxLength={10}
                    required
                    autoComplete="off"
                  />
                </div>
                {error && <p className="text-[#fc0000]">{error}</p>}
                <div className="flex justify-end">
                  <button
                    // onSubmit={handleSubmit}
                    type="submit"
                    className="bg-[#FCDD00] text-[#1A1A1A] w-[100px] px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  };